/* eslint-disable react/no-unknown-property */
import React, { useMemo } from 'react';
import { useDeviationSeoData } from '../../../hooks/useDeviationSeoData';
import { PapiDeviation } from '@wix/da-papi-types';

import s from './SeoData.scss';

interface Props {
  deviation: PapiDeviation;
}

const SeoData: React.FC<Props> = ({ deviation }) => {
  const seoData = useDeviationSeoData(deviation);
  return useMemo(
    () => (
      <>
        {Object.entries(seoData).map(([key, val]) => {
          return key === 'creator' ? (
            <span key={key} className={s['seo-data']} rel="schema:creator">
              <span className={s['seo-data']} typeof="schema:Person">
                <span
                  property="schema:name"
                  className={s['seo-data']}
                  content={`${val}`}
                ></span>
              </span>
            </span>
          ) : (
            <span key={key} property={key} className={s['seo-data']}>
              {val}
            </span>
          );
        })}
      </>
    ),
    [seoData]
  );
};
SeoData.displayName = 'SeoData';

export default SeoData;
